module.exports = __webpack_public_path__ + "static/1_1_defineai-361736a31f6683bac6c9ca4bd2995f85.svg";